import { equals } from 'ramda';
import {
    DYNAMIC_CATEGORIES_FETCHED,
    GAMES_PUSH,
    SET_CATEGORIES,
    SET_EXPANDED_CATEGORY,
    SET_FEED,
    SET_FILTERED_CATEGORIES,
    SET_IMAGES_LOADED,
    SET_RECENTLY_PLAYED,
    SET_SEARCH_ACTIVE
} from 'js/components/main/Games/actions';
import { SET_AVAILABLE_CATEGORIES } from './server';
import {
    DELETE_FILTER,
    RESET_FILTERS,
    SET_FILTER_CATEGORIES,
    SET_FILTER_PROVIDERS,
    SET_FILTER_FEATURES,
    SET_FILTER_VOLATILITY
} from './Filters/actions';
import { CATEGORY_TYPE } from 'js/components/main/Games/constants';
export const initialState = {
    feedName: '',
    feed: {},
    categories: [],
    dynamicCategories: [],
    isDynamicCategoriesFetched: false,
    filters: {
        selectedCategories: [],
        selectedProviders: [],
        selectedFeatures: [],
        selectedVolatility: 0
    },
    groupedFilteredCategories: {
        tabs: [],
        sliders: [],
        length: 0
    },
    expandedCategory: null,
    recentlyPlayedGames: [],
    isSearchActive: false,
    isImagesLoaded: false,
    isLoadedCategories: false
};

export default (reducerSuffix) => (state = initialState, action) => {
    switch (action.type) {
        case GAMES_PUSH:
        case GAMES_PUSH + reducerSuffix: {
            if (action.payload.ID !== 31133) {
                return state;
            }

            const { notification = {} } = action.payload.data;
            const { notificationPlayerTagChangeInfo = {} } = notification;
            const { tag, value } = notificationPlayerTagChangeInfo;

            if (tag !== 'uam/hidden/playerRecentGames') {
                return state;
            }

            const gameCodes = typeof value === 'string' ? JSON.parse(value) : value;
            const recentlyPlayedGames = gameCodes || [];

            if (equals(recentlyPlayedGames, state.recentlyPlayedGames)) {
                return state;
            }

            return {
                ...state,
                recentlyPlayedGames
            };
        }

        case SET_FEED:
        case SET_FEED + reducerSuffix: {
            const { feedName, feed } = action.payload;

            return {
                ...state,
                feedName,
                feed
            };
        }

        case SET_CATEGORIES:
        case SET_CATEGORIES + reducerSuffix: {
            const categories = action.payload;

            return {
                ...state,
                categories
            };
        }

        // region Filters

        case SET_FILTER_CATEGORIES:
        case SET_FILTER_CATEGORIES + reducerSuffix: {
            const selectedCategories = action.payload;

            return {
                ...state,
                filters: {
                    ...state.filters,
                    selectedCategories
                },
                expandedCategory: null
            };
        }

        case SET_FILTER_FEATURES:
        case SET_FILTER_FEATURES + reducerSuffix: {
            const selectedFeatures = action.payload;

            return {
                ...state,
                filters: {
                    ...state.filters,
                    selectedFeatures
                },
                expandedCategory: null
            };
        }

        case SET_FILTER_PROVIDERS:
        case SET_FILTER_PROVIDERS + reducerSuffix: {
            const selectedProviders = action.payload;

            return {
                ...state,
                filters: {
                    ...state.filters,
                    selectedProviders
                },
                expandedCategory: null
            };
        }

        case SET_FILTER_VOLATILITY:
        case SET_FILTER_VOLATILITY + reducerSuffix: {
            const selectedVolatility = action.payload;

            return {
                ...state,
                filters: {
                    ...state.filters,
                    selectedVolatility
                },
                expandedCategory: null
            };
        }

        case DELETE_FILTER:
        case DELETE_FILTER + reducerSuffix: {
            const filterId = action.payload;
            const { selectedCategories, selectedFeatures, selectedProviders } = state.filters;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    selectedCategories: selectedCategories.filter(i => i !== filterId),
                    selectedProviders: selectedProviders.filter(i => i !== filterId),
                    selectedFeatures: selectedFeatures.filter(i => i !== filterId)
                },
                expandedCategory: null
            };
        }

        case RESET_FILTERS:
        case RESET_FILTERS + reducerSuffix: {
            return {
                ...state,
                filters: initialState.filters,
                expandedCategory: null
            };
        }

        // endregion Filters

        case SET_FILTERED_CATEGORIES:
        case SET_FILTERED_CATEGORIES + reducerSuffix: {
            const filteredCategories = action.payload;
            const tabs = filteredCategories?.filter(item => item.type === CATEGORY_TYPE.TAB) || [];
            const sliders = filteredCategories?.filter(item => item.type !== CATEGORY_TYPE.TAB) || [];
            const length = tabs.length + sliders.length;

            return {
                ...state,
                groupedFilteredCategories: {
                    tabs,
                    sliders,
                    length
                }
            };
        }

        case DYNAMIC_CATEGORIES_FETCHED:
        case DYNAMIC_CATEGORIES_FETCHED + reducerSuffix: {
            const nextState = {
                ...state,
                isDynamicCategoriesFetched: true
            };
            const data = action.payload;
            if (data) {
                nextState.dynamicCategories = data;
            }

            return nextState;
        }

        case SET_AVAILABLE_CATEGORIES:
        case SET_AVAILABLE_CATEGORIES + reducerSuffix: {
            const category = action.payload;

            return {
                ...state,
                isLoadedCategories: Boolean(category)
            };
        }

        case SET_RECENTLY_PLAYED:
        case SET_RECENTLY_PLAYED + reducerSuffix: {
            const { gamesCodes = [] } = action.payload;

            return {
                ...state,
                recentlyPlayedGames: gamesCodes
            };
        }

        case SET_EXPANDED_CATEGORY:
        case SET_EXPANDED_CATEGORY + reducerSuffix: {
            const newExpandedCategory = action.payload;
            const expandedCategory = newExpandedCategory !== state.expandedCategory
                ? newExpandedCategory
                : null;

            return {
                ...state,
                expandedCategory
            };
        }

        case SET_SEARCH_ACTIVE:
        case SET_SEARCH_ACTIVE + reducerSuffix: {
            const isSearchActive = action.payload;

            return {
                ...state,
                isSearchActive
            };
        }

        case SET_IMAGES_LOADED:
        case SET_IMAGES_LOADED + reducerSuffix: {
            return {
                ...state,
                isImagesLoaded: true
            };
        }

        default:
            return state;
    }
};
